import { CHART_PREFERENCES_DEFAULT_VALUES, DEFAULT_CHART_PREFERENCES } from './styleConsts'
import { cloneDeep } from 'lodash'
import styleTabStyles from './StyleTab.module.scss'
import utilsStyles from './utils.module.scss'
import { ScoopText, ScoopSelector, ScoopColorPicker } from '../../../../ui'

export function renderSelector(label, value, setValue, options) {
    // Normalize options to always be {label, value} format
    const normalizedOptions = options.map((opt) =>
        typeof opt === 'string' ? { label: opt, value: opt } : opt
    )

    return (
        <ScoopSelector
            value={value}
            label={label}
            onChange={(e) => setValue(e.target.value)}
            options={normalizedOptions}
            size="md"
            removeMargin
        />
    )
}

export function renderColorPicker(label, color, setColor) {
    return (
        <div className={utilsStyles.colorPickerColumn}>
            {label && <ScoopText className={styleTabStyles.styleConfigLabel}>{label}</ScoopText>}
            <div className={utilsStyles.colorPickerPadding}>
                <ScoopColorPicker showLabel value={color} onChange={(color) => setColor(color)} />
            </div>
        </div>
    )
}

export function renderBoxSelector(title, selected, onClick) {
    const className = selected
        ? `${utilsStyles.boxSelector} ${utilsStyles.selected}`
        : utilsStyles.boxSelector

    return (
        <div className={className} onClick={onClick}>
            <ScoopText className={utilsStyles.boxSelectorText}>{title}</ScoopText>
        </div>
    )
}

export const getDefaultChartPreferences = (darkTheme) => {
    const themeString = JSON.stringify(cloneDeep(CHART_PREFERENCES_DEFAULT_VALUES))
    if (darkTheme)
        return themeString.replaceAll('#6E7079', '#FFFFFF').replaceAll('#000000FF', '#FFFFFF')
    return themeString
}

export const getEmptyTheme = () => {
    return JSON.parse(JSON.stringify(DEFAULT_CHART_PREFERENCES))
}

export const propExistsOnObject = (override, prop) => {
    return override && override[prop] !== undefined
}
